import React from "react";
import { Badge } from "../../../../ui/components/Badge";
import { JournalEntity } from "../../domain";

interface JournalStatusChipProps {
  journal: JournalEntity;
}

export const JournalStatusChip: React.FC<JournalStatusChipProps> = ({
  journal,
}) => {
  if (journal.journal_type === "ap_ar") {
    return <Badge variant="brand">Ap/Ar</Badge>;
  }

  switch (journal.status) {
    case "approved":
      return <Badge variant="success">Approved</Badge>;
    case "rejected":
      return <Badge variant="error">Rejected</Badge>;
    case "save_as_draft":
    case "draft":
      return <Badge variant="brand">Saved as Draft</Badge>;
    case "under_review":
    default:
      return <Badge variant="neutral">Under Review</Badge>;
  }
};
